import React, { useCallback, useMemo, useState } from 'react';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import { TrustpilotApiReview } from './Trustpilot.types';
import { TrustpilotModal } from './TrustpilotModal';

export const useTrustpilotModal = ({ displayName, review }: {
  displayName?: string;
  review: TrustpilotApiReview;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const closeModal = useCallback(() => setOpenModal(false), []);

  const triggerModalOpen = () => setOpenModal(true);

  const { body, title } = review;

  const modalWrapper = useMemo(() => (
    openModal && (
      <Modal centered={false} dismissModal={closeModal} size="small">
        <TrustpilotModal body={body} title={title} vehicleMake={displayName} />
      </Modal>
    )
  ), [body, closeModal, displayName, openModal, title]);

  return {
    modalWrapper,
    triggerModalOpen,
  };
};
